<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { 
        fetchProyectos, 
        saveProyecto, 
        removeProyecto, 
        searchProyectos, 
        subscribeToProyectos, 
        unsubscribeFromProyectos 
    } from '../controllers/proyectoController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de proyectos
    let proyectoColumns = [
        { label: $t('fields.description'), field: 'descripcion', type: 'text' },
        { label: 'Responsable', field: 'responsable', type: 'text' },
        { label: $t('fields.startDate'), field: 'fecha_inicio', type: 'datetime' },
        { label: $t('fields.endDate'), field: 'fecha_cierre', type: 'datetime' },
        { label: 'Sucursal', field: 'sucursal', type: 'relation', relationField: 'descrip' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Proyecto
    let newProyecto = {
        descripcion: '',
        responsable: '',
        fecha_inicio: '0000-00-00',
        fecha_cierre: "0000-00-00",
        sucursal: null, // Relación con la sucursal
        sta: true,
    };

    // Configuración de los campos para la edición de proyectos
    let editColumns = [
        { label: $t('fields.description'), key: 'descripcion', type: 'text', required: true },
        { label: 'Responsable', key: 'responsable', type: 'text', required: true },
        { label: $t('fields.startDate'), key: 'fecha_inicio', type: 'text', required: true },
        { label: $t('fields.endDate'), key: 'fecha_cierre', type: 'text', required: false },
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
    ];

    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.proyectos')}
    entityName="proyecto"
    newEntity={newProyecto}
    columns={proyectoColumns}
    fetchEntities={fetchProyectos}
    saveEntity={saveProyecto}
    removeEntity={removeProyecto}
    searchEntities={searchProyectos}
    subscribeToChanges={subscribeToProyectos}
    unsubscribeFromChanges={unsubscribeFromProyectos}
    editColumns={editColumns}
/>
